// extracted by mini-css-extract-plugin
export var lg = "_redotech-arbiter-lib-flag-flag-lg";
export var md = "_redotech-arbiter-lib-flag-flag-md";
export var sm = "_redotech-arbiter-lib-flag-flag-sm";
export var xs = "_redotech-arbiter-lib-flag-flag-xs";
export var xxs = "_redotech-arbiter-lib-flag-flag-xxs";